module.exports = __webpack_public_path__ + "static/media/accessory__IRSensor.0bc9f169.jpg";